import I18n from 'I18n';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { Text } from 'foundations-components/components/Text';
import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { getStatusSeverity } from 'integrations-lib/utils/connectedAppStatusUtils';
import { CtaReconnectButton } from 'integrations-lib/modules/reconnect/components/reconnectButton/CtaReconnectButton';
import { getAppNameByAppId } from 'integrations-lib/constants/AppIds';
import { GoToSettingsButton } from '../../GoToSettingsButton/GoToSettingsButton';
import { connectionsEmbedInteraction } from '../../../utils/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const getSingleAccountOptions = ({
  alertStore,
  loading,
  onAuthSucceeded,
  setTooltipOpen,
  statusData,
  tracker
}) => {
  const {
    appId,
    externalAccountId,
    businessUnitId,
    status: statusText,
    type: statusType,
    cta: {
      message,
      link: ctaLink
    },
    metadata: {
      ctaButtonText,
      hollowStyle,
      severity
    }
  } = statusData;
  const statusSeverity = getStatusSeverity(severity);
  const tooltipDisabled = statusType === AppConnectionStatuses.OK || statusType === AppConnectionStatuses.NO_STATUS_AVAILABLE;
  const tooltipHeadingText = statusText;
  const tooltipMessage = message;
  const showStatus = statusType !== AppConnectionStatuses.NO_STATUS_AVAILABLE;
  const content = showStatus ? /*#__PURE__*/_jsx(StatusTag, {
    use: statusSeverity,
    hollow: hollowStyle,
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "detail-100",
      textDecoration: tooltipDisabled ? 'none' : 'underline',
      children: statusText
    })
  }) : null;
  const ctaButton = showStatus ? /*#__PURE__*/_jsx(CtaReconnectButton, {
    buttonProps: {
      marginBlockStart: '600',
      onClick: () => {
        const appName = getAppNameByAppId(appId) || '';
        setTooltipOpen(true);
        connectionsEmbedInteraction({
          action: 'click-reconnect-button',
          appId,
          appName,
          actionMeta: statusType
        });
        tracker === null || tracker === void 0 || tracker({
          action: 'click-reconnect-button',
          appId,
          appName,
          actionMeta: statusType
        });
      },
      loading
    },
    label: ctaButtonText,
    metadata: {
      appId,
      accountId: externalAccountId,
      businessUnitId,
      status: statusType
    },
    url: ctaLink,
    onAuthSucceeded: onAuthSucceeded,
    onAuthCancelled: args => {
      setTooltipOpen(undefined);
      const title = I18n.text('reconnectionErrors.genericTitle');
      const hasError = (args === null || args === void 0 ? void 0 : args.error) || (args === null || args === void 0 ? void 0 : args.errorMessage);

      /**
       * The field `errorMessage` should contain the info for customers about the cause of an issue
       * If `errorMessage` does not exist then we show the generic message
       */
      const errorMessageText = hasError ? (args === null || args === void 0 ? void 0 : args.errorMessage) || I18n.text('reconnectionErrors.reconnectionFailed') : I18n.text('reconnectionErrors.reconnectionCancelled');
      alertStore === null || alertStore === void 0 || alertStore.addAlert({
        titleText: title,
        message: errorMessageText,
        type: 'danger',
        timeout: 2000
      });
    },
    fallback: /*#__PURE__*/_jsx(GoToSettingsButton, {
      appId: appId
    })
  }) : null;
  return {
    content,
    ctaButton,
    tooltipDisabled,
    tooltipHeadingText,
    tooltipMessage
  };
};